import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  activeOrders: [],
  orderHistory: [],
  currentOrder: null,
  isPlacingOrder: false,
  error: null,
}

const ordersSlice = createSlice({
  name: 'orders',
  initialState,
  reducers: {
    setActiveOrders: (state, action) => {
      state.activeOrders = action.payload
    },
    setOrderHistory: (state, action) => {
      state.orderHistory = action.payload
    },
    addOrder: (state, action) => {
      state.activeOrders.push(action.payload)
      state.currentOrder = null
    },
    updateOrderStatus: (state, action) => {
      const { orderId, status } = action.payload
      const order = state.activeOrders.find(o => o.id === orderId)
      if (order) {
        order.status = status
        order.updatedAt = new Date().toISOString()
      }
    },
    setCurrentOrder: (state, action) => {
      state.currentOrder = action.payload
    },
    clearCurrentOrder: (state) => {
      state.currentOrder = null
    },
    setPlacingOrder: (state, action) => {
      state.isPlacingOrder = action.payload
    },
    setOrderError: (state, action) => {
      state.error = action.payload
    },
    clearOrderError: (state) => {
      state.error = null
    },
  },
})

export const {
  setActiveOrders,
  setOrderHistory,
  addOrder,
  updateOrderStatus,
  setCurrentOrder,
  clearCurrentOrder,
  setPlacingOrder,
  setOrderError,
  clearOrderError,
} = ordersSlice.actions

export default ordersSlice.reducer

// Selectors
export const selectActiveOrders = (state) => state.orders.activeOrders
export const selectOrderHistory = (state) => state.orders.orderHistory
export const selectCurrentOrder = (state) => state.orders.currentOrder
export const selectIsPlacingOrder = (state) => state.orders.isPlacingOrder